import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../core/config/config.service';
import { PainelResumoDTO } from '../models/painel.model';

@Injectable({ providedIn: 'root' })
export class PainelService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  resumo(): Observable<PainelResumoDTO> {
    return this.http.get<PainelResumoDTO>(`${this.apiUrl}/painel/resumo`);
  }

  private get apiUrl(): string | undefined {
    return this.config.settings()?.apiUrl;
  }
}
